import { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { handleEvents } from "./eventHandler";

const jsToHtml = (code: string) => `<!doctype html>
<html lang="en">

<head>
<meta http-equiv="Content-Security-Policy" content="default-src * self blob: data: gap:; style-src * self 'unsafe-inline' blob: data: gap:; script-src * 'self' 'unsafe-eval' 'unsafe-inline' blob: data: gap:; object-src * 'self' blob: data: gap:; img-src * self 'unsafe-inline' blob: data: gap:; connect-src self * 'unsafe-inline' blob: data: gap:; frame-src * self blob: data: gap:;">
</head>

<body>
    <style>
        body {
            margin: 0;
            overflow: hidden
        }
    </style>
    <div id="root"></div>
<script>${code}</script>`;

export type GameData = {
    id: string;
    title: string;
    js: string;
};

const Game = () => {
    const { gameId } = useParams();
    const [game, setGame] = useState<GameData | null>(null);

    useEffect(() => {
        if (gameId === undefined) return;
        (async () => {
            setGame({ ...(await getDoc(doc(db, "games", gameId))).data(), id: gameId } as GameData);
        })();
    }, [gameId]);

    useEffect(() => {
        if (game === null) return;
        document.title = game.title;
        const iframe = document.createElement("iframe");
        const unsubscribe = handleEvents(game.id);
        iframe.style.display = "block";
        iframe.style.border = "none";
        iframe.width = "100%";
        iframe.height = "100%";
        document.body.appendChild(iframe);
        if (iframe.contentDocument) iframe.contentDocument.write(jsToHtml(game.js));
        return () => {
            document.body.removeChild(iframe);
            unsubscribe();
        };
    }, [game]);

    return <div />;
};

export default Game;
